import beaconLogo from 'assets/BeaconLogoFull.svg';
import successImage from 'assets/sucess.png';

import styles from './styles.module.scss';

export const PaymentsSuccess = () => (
  <div className={styles.container}>
    <div className={styles.header}>
      <img src={beaconLogo} alt="Beacon AI" className={styles.logo} />
    </div>

    <div className={styles.content}>
      <img src={successImage} alt="Success" className={styles.successImage} />

      <div className={styles.heading}>
        <h1 className={styles.title}>
          You're all set!
        </h1>
        <p className={styles.subtitle}>
          Ready to enjoy your Pro features?
        </p>
        <p className={styles.description}>
          Head back to the AI Design Reviewer plugin and enjoy your new superpowers
        </p>
      </div>
    </div>
    <div className={styles.blur} />
  </div>
);
